// src/belediye/components/icons/appIcons.js
//
// İKON SÖZLÜĞÜ — TEK KAYNAK (FAZ-51).
//
// Neden var: aynı kavram ekrandan ekrana farklı ikonla çiziliyordu ve daha
// kötüsü FARKLI kavramlar aynı ikonu paylaşıyordu. `ClipboardDocumentListIcon`
// hem görev, hem rapor filtresi, hem başvuru aksiyon panelinde kullanılıyordu;
// sohbet listesinde görev/başvuru/grup/doğrudan sohbetlerin HEPSİ aynı çift
// balonla görünüyordu — kullanıcı sohbetin türünü ikondan ayırt edemiyordu.
//
// Kural: kavramın ikonu BURADAN gelir. Bir ekranda ikon değiştirmek isteyen
// önce buraya bakar; böylece "her yerde değişsin" tek satırlık iş olur.
//
// Kavram → ikon eşlemesi (kullanıcı kararı 2026-07-27):
//   Görev            → Briefcase  (eski: ClipboardDocumentList — pano ikonu
//                                  raporlarla/başvuruyla karışıyordu)
//   Doğrudan sohbet  → ChatBubbleLeft      (tek balon = tek kişi)
//   Grup sohbeti     → UserGroup           (çok kişi)
//   Görev sohbeti    → Briefcase           (görevle AYNI — aynı şey konuşuluyor)
//   Başvuru sohbeti  → DocumentText        (başvuru evrağı)
//   Mesajlaşma modülü→ ChatBubbleLeftRight (modülün kendi kimliği; tür değil)

import React from "react";
import {
  BriefcaseIcon,
  ChatBubbleLeftIcon,
  ChatBubbleLeftRightIcon,
  DocumentTextIcon,
  UserGroupIcon,
  BellIcon,
  MegaphoneIcon,
  ClipboardDocumentCheckIcon,
  // FAZ-90 — alt bar yuva ikonları
  HomeIcon,
  InboxArrowDownIcon,
  MagnifyingGlassIcon,
  PlusCircleIcon,
  WrenchScrewdriverIcon,
  UserCircleIcon,
  ShieldCheckIcon,
  BuildingOffice2Icon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/outline";

// FAZ-93 madde 6 — alt barda AKTİFLİK TEK SİNYALE İNER: dolu ikon.
// Kavram eşlemesi DEĞİŞMİYOR (K-5); yalnız aynı ikonun dolu varyantı.
// Ağaç-sarsma sayesinde pakete yalnız burada adı geçen 10 ikon giriyor.
import {
  HomeIcon as HomeSolid,
  InboxArrowDownIcon as InboxSolid,
  MagnifyingGlassIcon as AraSolid,
  PlusCircleIcon as ArtiSolid,
  WrenchScrewdriverIcon as SahaSolid,
  BriefcaseIcon as GorevSolid,
  UserCircleIcon as KisiSolid,
  ShieldCheckIcon as KalkanSolid,
  BuildingOffice2Icon as BinaSolid,
  ArrowRightOnRectangleIcon as CikisSolid,
} from "@heroicons/react/24/solid";

// ── Sohbet BAŞLATICI balonunun ikonu (FAZ-79) ──────────────────────────────
//
// Kullanıcı (2026-07-30): "buradaki mesaj ikonunu değiştirmeni istiyorum,
// heroicons'tan daha güzel bir mesajlaşma — tekli bir mesajlaşma ve WhatsApp'a
// benzeyen bir mesajlaşma ikonu ayarla."
//
// Heroicons'ın `ChatBubbleLeftRight`ı ÇİFT balondur (ince çizgi, "konuşma"
// kavramı). Balon 62px'e büyüyünce içindeki iki ince balon dağınık duruyordu.
// Bunun yerine WhatsApp'ın dilindeki tek şey: **dolu tek baloncuk + kuyruk**,
// içinde üç nokta. Dolu gövde büyük boyutta net okunur; kuyruk "mesaj" fikrini
// tek bakışta verir.
//
// Neden Heroicons'a bağlı kalınmadı: Heroicons'ta kuyruklu-dolu-baloncuk yok
// (`ChatBubbleOvalLeft` solid var ama kuyruğu WhatsApp'ın aksine SOL altta ve
// noktasız). İkon sözlüğünün amacı zaten "kavramın ikonu buradan gelir" —
// kaynağı kütüphane olmak zorunda değil.
//
// `className` dışarıdan gelir (CSS boyutu yönetir); `currentColor` ile
// düğmenin rengini alır.
//
// FAZ-102 — ARTIK HİÇBİR YERDE ÇİZİLMİYOR. Balon başlatıcısı ChatBarIcon'a
// geçti (aşağıdaki nota bakın). SİLİNMEDİ: bu, sistemin tek özgün çizimi ve
// "kuyruklu-dolu baloncuk" fikri ileride büyük yüzeylerde (karşılama ekranı,
// boş durum görseli) yeniden gerekebilir. Ölü kod sayılmaz — sözlüğün bir
// kalemi; kullanan olmadığı için de hiçbir ekranı etkilemiyor.
export const ChatLauncherIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    {/* Gövde + kuyruk TEK yol: sağ-alt köşede WhatsApp'taki gibi sivri çıkıntı */}
    <path
      d="M12 3.25c-4.83 0-8.75 3.36-8.75 7.5 0 2.2 1.11 4.18 2.87 5.54.2.15.3.4.26.65l-.5 3.04a.6.6 0 0 0 .87.63l3.2-1.72c.16-.09.35-.11.53-.06.79.2 1.63.32 2.52.32 4.83 0 8.75-3.36 8.75-7.5s-3.92-7.4-8.75-7.4Z"
      fill="currentColor"
    />
    {/* Üç nokta — baloncuğun içinde, zeminden oyulmuş gibi */}
    <circle cx="8.4" cy="10.75" r="1.15" className="msj-ic-dot" />
    <circle cx="12" cy="10.75" r="1.15" className="msj-ic-dot" />
    <circle cx="15.6" cy="10.75" r="1.15" className="msj-ic-dot" />
  </svg>
);

// ── Kavram ikonları ────────────────────────────────────────────────────────
export const TaskIcon = BriefcaseIcon;
export const ChatModuleIcon = ChatBubbleLeftRightIcon;
export const DirectChatIcon = ChatBubbleLeftIcon;
export const GroupChatIcon = UserGroupIcon;
export const ApplicationIcon = DocumentTextIcon;
export const NotificationIcon = BellIcon;
export const DuyuruIcon = MegaphoneIcon;
export const CloseApprovalIcon = ClipboardDocumentCheckIcon;

// ── Sohbet türü ────────────────────────────────────────────────────────────
// Backend Conversation.KIND_* değerleri: dogrudan | grup | gorev | basvuru
export const CONVERSATION_ICONS = {
  dogrudan: DirectChatIcon,
  dm: DirectChatIcon, // ChatDock'un convKind() çıktısı "dm" diyor
  grup: GroupChatIcon,
  gorev: TaskIcon,
  basvuru: ApplicationIcon,
};

export const CONVERSATION_LABELS = {
  dogrudan: "Doğrudan mesaj",
  dm: "Doğrudan mesaj",
  grup: "Grup sohbeti",
  gorev: "Talep sohbeti",
  basvuru: "Başvuru sohbeti",
};

export const conversationIcon = (kind) =>
  CONVERSATION_ICONS[String(kind || "").trim()] || ChatModuleIcon;

export const conversationLabel = (kind) =>
  CONVERSATION_LABELS[String(kind || "").trim()] || "Sohbet";

// ── Bildirim kaynağı → ikon ────────────────────────────────────────────────
// Bildirim merkezindeki satırın solundaki simge. Kaynak `source_module`
// (bildirim_app.sources kayıt defteri) değerleridir.
export const SOURCE_ICONS = {
  mesajlasma: ChatModuleIcon,
  gorev: TaskIcon,
  // FAZ-106: yeni başvuru bildirimi. Kapatma onayı (pano+tik) ile aynı sekmede
  // durur ama AYRI çizilir — biri "başvurunun kendisi", diğeri "o başvuru
  // üzerinde bir karar bekleniyor" demek.
  basvuru: ApplicationIcon,
  close_approval: CloseApprovalIcon,
  duyuru: DuyuruIcon,
  sistem: NotificationIcon,
};

export const sourceIcon = (source) =>
  SOURCE_ICONS[String(source || "").trim()] || NotificationIcon;

// ── ALT BAR MERKEZ İKONU (FAZ-92) ─────────────────────────────────────────
//
// Kullanıcı (2026-08-01): "sohbet ikonunu değiştir lütfen, daha mantıklı bir
// ikon yerleştir oraya."
//
// ChatLauncherIcon (FAZ-79) sağ-altta 62px'lik MOR balonun içindeydi: dolu
// gövde + üç nokta orada net okunuyordu. Alt barın merkezinde ikon 24px'e
// düştü; o ölçekte üç nokta birbirine giriyor ve dolu gövde "leke" gibi
// duruyor. Merkez düğme ayrıca bir SAYFA değil bir EYLEM anlatıyor.
//
// Yeni ikon: iki katmanlı konuşma — arkada ince bir balon, önde dolu bir
// balon. 24px'te iki ayrı yüzey olarak okunur, "karşılıklı konuşma" fikrini
// nokta kalabalığı olmadan verir.
//
// FAZ-102 — ARTIK BALON BAŞLATICISI DA BUNU KULLANIYOR.
// FAZ-92'de "balon başlatıcısı ChatLauncherIcon ile KALIR — orada ölçek ve
// zemin farklı" denmişti. Kullanıcı (2026-08-02) bunu geri aldı: "mobilde
// sohbetin ikonunu değiştirdin ya, aynı mantıkta web'teki kısımda da mobilde
// kullandığımız ikonu kullanalım." Ölçek gerekçesi teknik olarak doğruydu ama
// KAVRAM aynı; aynı kavramın iki yüzeyde iki ayrı çizimi, telefondan web'e
// geçen kullanıcıya iki ayrı şey gibi okunuyordu. Tek çizim kazandı.
export const ChatBarIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    {/* Arka balon — ince çizgi, derinlik verir */}
    <path
      d="M8.6 4.6h9.1a2.6 2.6 0 0 1 2.6 2.6v4.9a2.6 2.6 0 0 1-2.6 2.6h-.6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      opacity=".55"
    />
    {/* Ön balon — dolu gövde + sol-alt kuyruk */}
    <path
      d="M6.3 7.1h8.4a2.6 2.6 0 0 1 2.6 2.6v4.6a2.6 2.6 0 0 1-2.6 2.6H9.9l-3.3 2.5a.6.6 0 0 1-.96-.48v-2.1a2.6 2.6 0 0 1-1.94-2.51V9.7A2.6 2.6 0 0 1 6.3 7.1Z"
      fill="currentColor"
    />
  </svg>
);

// ── ALT BAR İKON SÖZLÜĞÜ (FAZ-90) ──────────────────────────────────────────
//
// altbar.js'teki yuvalar ikon BİLEŞENİ değil ikon ADI taşır (`icon: "ev"`).
// Sebep: altbar.js saf veri dosyası — React'e hiç bağımlı değil, bu yüzden
// saf fonksiyon olarak test edilebiliyor. Ad → bileşen eşlemesi burada.
export const ALTBAR_IKONLARI = {
  ev: HomeIcon,
  kutu: InboxArrowDownIcon,
  ara: MagnifyingGlassIcon,
  arti: PlusCircleIcon,
  saha: WrenchScrewdriverIcon,
  gorev: BriefcaseIcon, // TaskIcon ile AYNI — görev kavramı tek ikon
  kisi: UserCircleIcon,
  kalkan: ShieldCheckIcon,
  bina: BuildingOffice2Icon,
  cikis: ArrowRightOnRectangleIcon,
};

/* FAZ-93 madde 6 — DOLU varyantlar. Anahtarlar ALTBAR_IKONLARI ile birebir
   aynı; nöbetçi test iki sözlüğün anahtar kümesini karşılaştırıyor. */
export const ALTBAR_IKONLARI_DOLU = {
  ev: HomeSolid,
  kutu: InboxSolid,
  ara: AraSolid,
  arti: ArtiSolid,
  saha: SahaSolid,
  gorev: GorevSolid,
  kisi: KisiSolid,
  kalkan: KalkanSolid,
  bina: BinaSolid,
  cikis: CikisSolid,
};

/**
 * @param {boolean} dolu  Aktif yuvada true → solid varyant.
 *   FAZ-92'de aktiflik ÜÇ sinyalle veriliyordu (renk + zemin + üst çubuk);
 *   kullanıcı fazla buldu. Dolu ikon mobil gezinme barlarının evrensel dili
 *   ve tek başına yeterli.
 */
export const AltBarIkon = ({ ad, className, dolu = false }) => {
  const Icon = (dolu ? ALTBAR_IKONLARI_DOLU[ad] : null) || ALTBAR_IKONLARI[ad];
  if (!Icon) return null;
  return <Icon className={className} aria-hidden="true" />;
};
